import { render, staticRenderFns } from "./ChangeStatus.vue?vue&type=template&id=70ee1a66&scoped=true&"
import script from "./ChangeStatus.vue?vue&type=script&lang=js&"
export * from "./ChangeStatus.vue?vue&type=script&lang=js&"
import style0 from "./ChangeStatus.vue?vue&type=style&index=0&id=70ee1a66&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70ee1a66",
  null
  
)

component.options.__file = "ChangeStatus.vue"
export default component.exports